<div class="range-date-picker-container w-p-100 flex flex-row justify-start items-center">

  <div  class="m-r-20 w-p-100 flex flex-col justify-center items-start">
    <label class="component-label datepicker-label">From</label>
    <mat-form-field class="w-p-100" appearance="outline">
      <input matInput
             [matDatepicker]="picker1"
             [value]="fromDate"
             (dateChange)="onFromDateChange('change', $event)">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
  </div>


  <div class="w-p-100 flex flex-col justify-center items-start" >
    <label class="component-label datepicker-label">To</label>
    <mat-form-field class="w-p-100" appearance="outline">
      <input matInput [matDatepicker]="picker2"
             [value]="toDate"
             (dateChange)="onToDateChange('change', $event)">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>

</div>
